module.exports = __webpack_public_path__ + "img/2400_YR_2022_Amazon-Logo.e6ecb0fb.png";